/* Dock */
.dock {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: var(--space-2);
  background: var(--color-surface);
  border: var(--border-medium) var(--border-style) var(--color-border-strong);
  border-radius: var(--radius-window);
  padding: var(--space-2) var(--space-3);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 50;
}

.dockMain {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.dockIcon {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface-sunken);
  border: var(--border-thin) var(--border-style) var(--color-border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: transform var(--duration-normal) var(--ease-out),
              background var(--duration-normal) var(--ease-out),
              box-shadow var(--duration-normal) var(--ease-out);
}

.dockIcon:hover {
  transform: translateY(-4px);
  background: var(--color-surface-raised);
  box-shadow: 0 0 10px rgba(90, 120, 176, 0.4),
              0 0 4px rgba(90, 120, 176, 0.2);
}

.dockIcon.active {
  background: var(--color-surface);
  border-color: var(--color-border-strong);
}

.dockIconEmoji {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: var(--color-text);
}

.dockIconEmoji svg {
  width: 100%;
  height: 100%;
}

.dockIndicator {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  background: var(--color-accent-primary);
  border-radius: 50%;
}

.dockDivider {
  width: 1px;
  height: 32px;
  background: var(--color-border);
  margin: 0 var(--space-1);
}

.dockMinimized {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.dockMinimizedWindow {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: var(--space-1) var(--space-2);
  background: var(--color-surface-sunken);
  border: var(--border-thin) var(--border-style) var(--color-border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: transform var(--duration-normal) var(--ease-out),
              background var(--duration-normal) var(--ease-out),
              box-shadow var(--duration-normal) var(--ease-out);
  max-width: 60px;
}

.dockMinimizedWindow:hover {
  transform: translateY(-4px);
  background: var(--color-surface-raised);
  box-shadow: 0 0 10px rgba(90, 120, 176, 0.4),
              0 0 4px rgba(90, 120, 176, 0.2);
}

.minimizedIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  color: var(--color-text);
}

.minimizedIcon svg {
  width: 100%;
  height: 100%;
}

.minimizedTitle {
  font-family: var(--font-mono);
  font-size: 9px;
  color: var(--color-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
